import axios from '@/axios'

export default {
  removeMember(memberId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/team-members/${memberId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  membersForEntry(entryId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/team-members/membersforentry/${entryId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  addMember(entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/team-members`, entry)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  sendTeamMemberJoinEmail(
    email,
    captainsfirstname,
    firstname,
    surname,
    teamname,
    eventname
  ) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/team-members/send-teammemberjoin-email`, {
          email: email,
          captainsfirstname: captainsfirstname,
          firstname: firstname,
          surname: surname,
          teamname: teamname,
          eventname: eventname
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  showEntryByEvent(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/team-members/event/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  updateEntry(entry) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/team-members/${entry._id}`, entry)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  }
}
